var React = require('react');

function YtInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"width":"32","height":"32.276","fill":"#FFF","rx":"2","key":0}),React.createElement("path",{"fill":"#005285","d":"M13.545 20.26v-7.236l6.273 3.618-6.273 3.619zm13.953-9.514a3.037 3.037 0 0 0-2.121-2.165C23.505 8.069 16 8.069 16 8.069s-7.505 0-9.377.512a3.037 3.037 0 0 0-2.121 2.165C4 12.656 4 16.642 4 16.642s0 3.986.502 5.896a3.038 3.038 0 0 0 2.121 2.166c1.872.512 9.377.512 9.377.512s7.505 0 9.377-.512a3.038 3.038 0 0 0 2.121-2.166c.502-1.91.502-5.896.502-5.896s0-3.985-.502-5.896z","key":1})]));
}

YtInline.defaultProps = {"width":"32","height":"33","viewBox":"0 0 32 33"};

module.exports = YtInline;

YtInline.default = YtInline;
